import { EditGMNMeasuringPointTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGmnLibraryFields } from "../../../schema/gmn-schema-library";

export const getEditGmnMeasuringPointSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGMNMeasuringPointTask> => ({
  type: "object",
  title: `GMN-Meetpunt aanpassen ${getTitleAddon(type)}`,
  description: `Dit is het GMN Meetpunt aanpassen formulier. ${getDocsLinkMarkdown("GMN")}`,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickGmnLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGmnLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: {
      type: "object",
      required: ["eventType", "eventDate", "measuringPointCode", "tubeNumber"],
      properties: {
        ...pickGmnLibraryFields(["eventType", "eventDate", "measuringPointCode", "tubeNumber"]),
        // broId here is the GMW BRO-ID (tube), not the GMN BRO-ID
        broId: { type: "string" as const, title: "BRO-ID Put" },
      },
    },
  },
});
